import { render, staticRenderFns } from "./ScreenEdit.vue?vue&type=template&id=683825ea"
import script from "./ScreenEdit.vue?vue&type=script&lang=js"
export * from "./ScreenEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports